import { useContext } from "react";
import { Divider, Flex, Radio, Text } from "@simplybusiness/mobius";
import { currencyFormatter } from "../UtilsHelper";
import { CombinedPaymentContext } from "../CombinedPaymentContext";

export const PaymentOption = ({
  label,
  value,
  toPayToday,
  installment,
  currency,
  hasMonthlyFees,
  ...otherProps
}: PaymentOptionProps) => {
  const isCombinedPaymentPage = useContext(CombinedPaymentContext);
  const formatter = currencyFormatter(currency);
  if (toPayToday == null) return null;

  return (
    <Radio
      className="sb-brand"
      data-testid={value}
      value={value}
      label={label}
      {...otherProps}
    >
      <Flex
        className={`${isCombinedPaymentPage ? "combined-styles" : undefined} mobius-payment-summary__styled-wrapper`}
      >
        <Flex className="mobius-payment-summary__styled-flex">
          <Text variant="small" className="today-payment">
            To pay today
          </Text>
          <Text variant="small" className="today-payment">
            {formatter.format(toPayToday)}
          </Text>
        </Flex>
        {installment && Object.keys(installment).length > 0 && (
          <>
            <Flex className="mobius-payment-summary__styled-flex">
              <Text variant="small" className="monthly-payment">
                {installment.count} monthly payments of
              </Text>
              <Text variant="small" className="monthly-payment">
                {formatter.format(installment.amount)}
              </Text>
            </Flex>
            <Divider className="mobius-payment-summary__styled-divider" />
            <Flex className="mobius-payment-summary__styled-flex">
              <Text variant="small">Total</Text>
              <Text variant="small" className="total-payment">
                {hasMonthlyFees
                  ? formatter.format(
                      installment.count * installment.amount + toPayToday,
                    )
                  : formatter.format(installment.total)}
              </Text>
            </Flex>
          </>
        )}
      </Flex>
    </Radio>
  );
};

export type PaymentOptionProps = {
  label: string;
  value: string;
  toPayToday: number | null;
  installment?: {
    count: number;
    amount: number;
    total: number;
  };
  hasMonthlyFees?: boolean;
  currency: string;
};
